import React from 'react';
import { MapPin, Phone, Heart } from 'lucide-react';
import { companyInfo, navigationItems } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-navy-950 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_dumangin-admin/artifacts/wys87xtq_2ea06688a_logohorizontalGOODquality.png" 
                alt="DumanginADM" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-white/60 leading-relaxed max-w-md mb-6">
              Administração inteligente, marketing estratégico e marcas que se destacam. 
              Cuidamos do seu negócio como se fosse nosso.
            </p>
            <div className="flex items-center gap-4 text-white/50">
              <div className="flex items-center gap-2">
                <MapPin size={16} className="text-gold-500" />
                <span className="text-sm">{companyInfo.contact.location}</span>
              </div>
              <span>|</span>
              <div className="flex items-center gap-2">
                <Phone size={16} className="text-gold-500" />
                <span className="text-sm">{companyInfo.contact.phone}</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold mb-6">Navegação</h4>
            <nav className="space-y-3">
              {navigationItems.map((item) => (
                <a
                  key={item.id}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                  className="block text-white/60 hover:text-gold-500 transition-colors duration-300"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Serviços</h4>
            <nav className="space-y-3">
              {['Gestão Empresarial', 'Branding', 'SEO', 'Inbound Marketing', 'Gestão de Conteúdo'].map((service) => (
                <span
                  key={service}
                  className="block text-white/60"
                >
                  {service}
                </span>
              ))}
            </nav>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} DumanginADM. Todos os direitos reservados.
          </p>
          <p className="text-white/40 text-sm flex items-center gap-1">
            Feito com <Heart size={14} className="text-gold-500" /> por DumanginADM
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
